export type ProcurementRole =
  | "PLANLAMA"
  | "SATIN_ALMA"
  | "SATIN_ALMA_MUDURU"
  | "GENEL_MUDUR"
  | "SISTEM_YONETICISI"
  | "GUEST";

const procurementRoles: ReadonlySet<string> = new Set<ProcurementRole>([
  "PLANLAMA",
  "SATIN_ALMA",
  "SATIN_ALMA_MUDURU",
  "GENEL_MUDUR",
  "SISTEM_YONETICISI",
  "GUEST",
]);

export function asProcurementRole(role: string): ProcurementRole {
  return procurementRoles.has(role) ? (role as ProcurementRole) : "GUEST";
}

export type RequestStatus =
  | "Onay bekliyor"
  | "Satın Alma değerlendirmesi bekleniyor"
  | "Onaya gönderilmeye hazır"
  | "Teklif toplanıyor"
  | "Revizyon"
  | "Düzeltme istendi"
  | "Onaylandı"
  | "Satın Almaya iletildi"
  | "Reddedildi"
  | "İptal edildi"
  | "Taslak";

export type RequestPriority = "Kritik" | "Yüksek" | "Normal";

export type ApprovalRole = "SATIN_ALMA_MUDURU" | "GENEL_MUDUR";
export type ApprovalStatus =
  "QUEUED" | "PENDING" | "APPROVED" | "REJECTED" | "REVISION_REQUESTED";

export type ApprovalChainEntry = {
  role: ApprovalRole;
  status: ApprovalStatus;
  decidedBy: string | null;
  decidedAt: string | null;
  decisionNote: string | null;
  decisionKind?: string | null;
  decidedOfferId?: string | null;
  decidedOfferNo?: string | null;
  decidedOfferSupplier?: string | null;
  revisionFields?: string[];
};

export type PurchaseRequest = {
  id: string;
  title: string;
  meta: string;
  category?: string;
  quantity?: number;
  unit?: string;
  neededAt?: string;
  createdAt?: string | null;
  department: string;
  requester: string;
  amount: string;
  due: string;
  offers: number;
  offerCount?: number;
  status: RequestStatus;
  priority: RequestPriority;
  score: number;
  supplier: string;
  supplierMeta: string;
  saving: string;
  payment: string;
  delivery: string;
  rationale: string;
  pendingApprovalRole?: ApprovalRole | null;
  approvalChain?: ApprovalChainEntry[];
};

export type RequestComment = {
  id: string;
  author: string;
  body: string;
  visibility: string;
  createdAt: string;
};

export type RequestAttachment = {
  id: string;
  name: string;
  contentType: string;
  sizeBytes: number;
  scanStatus: string;
  createdAt: string;
  downloadUrl: string;
  offerNo: string | null;
  uploadedBy: string | null;
  uploadedByRole: string | null;
};

export type RequestWorkspaceOffer = {
  offerNo: string;
  supplier: string;
};

export type RequestHistoryEntry = {
  id: string;
  action: string;
  actor: string | null;
  outcome: string;
  occurredAt: string;
};

export type RequestWorkspaceDetail = {
  id: string;
  title: string;
  description: string;
  category: string;
  quantity: number;
  unit: string;
  department: string;
  requester: string;
  neededAt: string;
  status: string;
  priority: string;
  comments: RequestComment[];
  offers?: RequestWorkspaceOffer[];
  offerCount?: number;
  attachments: RequestAttachment[];
  history: RequestHistoryEntry[];
};

export type CorrectionTask = {
  id: string;
  requestNo: string;
  title: string;
  targetRole: "PLANLAMA" | "SATIN_ALMA" | "SATIN_ALMA_MUDURU";
  correctionType:
    | "REQUEST_DETAILS"
    | "COMMERCIAL_TERMS"
    | "EXPERT_CORRECTION"
    | "GM_REJECTION";
  fields: string[];
  instruction: string;
  status: "OPEN" | "IN_PROGRESS" | "RESOLVED";
  requestedBy: string;
  requestedAt: string;
  dueAt: string;
  acknowledgedBy: string | null;
  acknowledgedAt: string | null;
  requestVersion: number;
  requestVersionAtCreation: number;
  hasOfferChange: boolean;
};

export type ProcurementStage =
  | "Teklif Bekliyor"
  | "Uzman Hazırlıyor"
  | "Müdür Onayında"
  | "Genel Müdür Onayında"
  | "Reddedildi"
  | "Tamamlandı";

export type ProcurementAction =
  | "ACCEPT_REQUEST"
  | "MANAGE_OFFERS"
  | "PREPARE_RECOMMENDATION"
  | "SEND_TO_MANAGER"
  | "COMPLETE_CORRECTION"
  | "RETURN_TO_SPECIALIST"
  | "SEND_TO_GENERAL_MANAGER"
  | "APPROVE_FINAL"
  | "REJECT_FINAL"
  | "TRACK";
